import { render } from "./spaceBetweenLabel.vue?vue&type=template&id=22de285e"
import script from "./spaceBetweenLabel.vue?vue&type=script&lang=js"
export * from "./spaceBetweenLabel.vue?vue&type=script&lang=js"

import "./spaceBetweenLabel.vue?vue&type=style&index=0&id=22de285e&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__